import React, { createContext, useEffect, useState } from 'react';
export const VIEWPORTS = { DESKTOP: 1087 };
export const DimensionsContext = createContext({});
const { Provider } = DimensionsContext;
export const DimensionsProvider = ({ children }) => {
    const [isMobile, setMobile] = useState(false);
    const [isCrawler, setCrawler] = useState(true);
    useEffect(() => {
        const listener = () => setMobile(window.innerWidth < VIEWPORTS.DESKTOP);
        listener();
        setCrawler(false);
        window.addEventListener('resize', listener);
        return () => window.removeEventListener('resize', listener);
    }, []);
    return (React.createElement(Provider, { value: { isMobile, isCrawler } }, children));
};
//# sourceMappingURL=DimensionsContext.js.map